import { apiFetch } from "../useApi";

export default async function createCampaign({ name, type }) {
  const response = await apiFetch(`/campaigns`, {
    method: 'POST',
    body: JSON.stringify({ name, type }),
  });
}
